import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import CustomersPowerSelect from '../customers/customers-power-select.jsx';
import RecentJobsPowerSelect from './recent-jobs-power-select.jsx';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-power-select/dist/react-power-select.css';
import { Animate } from 'react-simple-animate';
import DriversPowerSelect from '../drivers/drivers-power-select.jsx';
import moment from 'moment';

export default class AddNewJob extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      selectedCustomerId: null,
      selectedCustomer: null,
      selectedJobId: null,
      selectedJob: null,
      showAutofill: false,
      job_admin_fee_in_pence: 0,
      job_admin_fee_in_pence_formatted: '',
      // minimum_fuel_amount_in_pense:0,
      // minimum_fuel_amount_in_pense_formatted:'',
      job_customer_provided_fuel_cost_in_pence: 0,
      job_customer_provided_mileage: 0,
      job_customer_provided_job_price_in_pence: 0,
      play: false,
      unit_term:null,
      units:[{
        //short
        unit_type:"",
        unit_number:"",
        unit_qty:"",
        date_of_event:null,
        pickup_date:null,
        dropoff_date:null,
        is_same_day_pickup_and_dropoff:false,
        is_weekend_dropoff_pickup:false,
        type_of_unit_service:"",
        number_of_weeks_required:"",
        can_we_dropoff_in_week_before:false,
        is_ongoing:false,
        required_date:null,
        collection_date:null,
      }],
      driver_id:null,
      isDisabledJobSplitting:false,
      jobTypeOption : 'delivery',
      specialInstructions : ''
  };
    this.handleVehicleRegistrationNumber = this.handleVehicleRegistrationNumber.
      bind(this);
    this.handleAllowBtnClickEvent = this.handleAllowBtnClickEvent.
      bind(this);
    this.handleDriverSelection = this.handleDriverSelection.bind(this);
    this.handleDisallowowBtnClickEvent = this.handleDisallowowBtnClickEvent.
      bind(this);
    this.handleCustomerSelection = this.handleCustomerSelection.
      bind(this);
    this.handleJobSelection = this.handleJobSelection.
      bind(this);
    this.isValidDateFormat = this.isValidDateFormat.bind(this);
    this.onAddNewJobCreate = this.onAddNewJobCreate.
      bind(this);
    this.handleDropoffDateCalendarChange = this.handleDropoffDateCalendarChange.
      bind(this);
    this.handlePickupDateCalendarChange = this.handlePickupDateCalendarChange.
      bind(this);
    this.handleAutofillButtonClick = this.handleAutofillButtonClick.
      bind(this);
    this.handleUnitHiredForChange = this.handleUnitHiredForChange.bind(this);
    this.handleAddMoreBtnClick = this.handleAddMoreBtnClick.bind(this);
    this.handleUnitNumberChange = this.handleUnitNumberChange.bind(this);
    this.handleUnitTypeChange = this.handleUnitTypeChange.bind(this);
    this.handleUnitQtyChange = this.handleUnitQtyChange.bind(this);
    this.handleUnitDateOfEventChange = this.handleUnitDateOfEventChange.bind(this);
    this.handleUnitPickupDateChange = this.handleUnitPickupDateChange.bind(this);
    this.handleUnitDropoffDateChange = this.handleUnitDropoffDateChange.bind(this);
    this.handleIsSamedayPickupAndDRopoffChange = this.handleIsSamedayPickupAndDRopoffChange.bind(this);
    this.handleIsWeekendDropoffPickupChange = this.handleIsWeekendDropoffPickupChange.bind(this);
    this.handleRemoveSelectedUnitContainer = this.handleRemoveSelectedUnitContainer.bind(this);
    this.handleTypeofUnitService = this.handleTypeofUnitService.bind(this);
    this.handleNumberOfWeeksRequiredChange = this.handleNumberOfWeeksRequiredChange.bind(this);
    this.handleUnitRequiredDateChange = this.handleUnitRequiredDateChange.bind(this);
    this.handleUnitCollectionDateChange = this.handleUnitCollectionDateChange.bind(this);
    this.handleCanweDropoffInWeekBeforeChange = this.handleCanweDropoffInWeekBeforeChange.bind(this);
    this.handleIsOngoingOptionChange = this.handleIsOngoingOptionChange.bind(this);
    this.handleDisableJobSplitting = this.handleDisableJobSplitting.bind(this);
    this.handleJobTypeOption = this.handleJobTypeOption.bind(this);
    this.setJobOptions = this.setJobOptions.bind(this);
  }
  componentDidMount() {
    this.setState({
      play: true
    });
    
  }
  
  handleVehicleRegistrationNumber(event){
        var  VehicleRegistrationNumber = event.target.value;
        return fetch(
            '/api/v1/portal/add-new-job/validation/vehicle/'+VehicleRegistrationNumber,
            {
              method: "GET",
              mode: "cors",
              cache: "no-cache",
              credentials: "same-origin",
              headers: {
                "Authorization": 'Bearer ' + window.api_token,
                "Accept": 'application/json'
              }
            }
          ).then((responseText) => {
                let infoModal = $('#infomodal');
                let response = responseText.json();
                let modalFooter = "";
                let msg = "";
                if(responseText.status === 302){
                    response.then((resJson) => {
                        if(resJson.jobs[0]){
                            msg = "This number plate is already in the system under job number <a target='_blank' href='jobs/view/"+resJson.jobs[0].id+"'>"+resJson.jobs[0].id+"</a>, Are you sure you wish to continue?";
                        }else{
                            msg = "This number plate is already on the system - do you wish to continue?";
                        }
                        document.querySelector('#infomodallabel').innerHTML = 'Already exists';
                        document.querySelector('#infomodal .modal-body').innerHTML = msg;
                        modalFooter += '<button type="button" class="btn btn-danger allow-number-plate" id="allow-number-plate" data-dismiss="modal">Yes</button>';
                        modalFooter += '<button type="button" class="btn btn-primary disallow-number-plate" data-dismiss="modal" id="disallow-number-plate">No</button>';
                        document.querySelector('#infomodal .modal-footer').innerHTML = modalFooter;
                        document.getElementById("allow-number-plate").addEventListener("click", this.handleAllowBtnClickEvent);
                        document.getElementById("disallow-number-plate").addEventListener("click", this.handleDisallowowBtnClickEvent);
                        infoModal.modal();
                    });
                }else if(responseText.status === 400){
                    response.then((resJson) => {
                        document.querySelector('#infomodallabel').innerHTML = 'Error';
                        document.querySelector('#infomodal .modal-body').innerHTML = resJson.message;
                        infoModal.modal();
                    });
                }
                
          });
       
  }
  handleAllowBtnClickEvent(e){
    e.preventDefault();
    window.setTimeout(function () { 
        document.getElementById('vehicle_vin_number').focus(); 
    }, 0); 
  }
  handleDriverSelection(selectedOption) {
    if(selectedOption)
    {
      this.setState({driver_id: selectedOption.id});
    }
  }
  handleDisallowowBtnClickEvent(e){
    e.preventDefault();
    window.setTimeout(function () { 
        document.getElementById('unit_number').focus(); 
    }, 0); 
  }
  handleCustomerSelection(option) {
    if (option) {
      // document.querySelector('[name=special_instructions]').value = option.customer_special_instruction;
      this.setState({
        selectedOption: option,
        selectedCustomer: option,
        selectedCustomerId: option.id,
        selectedJobId : this.state.selectedJobId
      });
      //$('#getpickupaddress_input').val('WV16 6SS');
    }
  }

  handleJobSelection(option) {
    if (!(option && option.id)) {
      return false;
    }
    if(option.customer)
    {
      this.handleCustomerSelection(option.customer);
    }
    // if((option.special_instructions!=null) && (option.special_instructions!= undefined) && (option.special_instructions!='undefined'))
    // {
    //   this.setState({ specialInstructions: option.special_instructions });
    // }
    if(option.driver)
    {
      this.handleDriverSelection(option.driver);
    }
    this.setState({
      selectedJobId: option.id,
      selectedJob: option,
    });
    document.querySelector(
      '[name=customer_order_number]'
    ).value = option.customer_order_number;
    document.querySelector(
      '[name=customer_job_number]'
    ).value = option.customer_job_number;
    document.querySelector(
      '[name=pickup_address_postcode]'
    ).value = option.pickup_address.postcode;
    document.querySelector(
      '[name=pickup_address_house_number_or_name]'
    ).value = option.pickup_address.house_number_or_name;
    document.querySelector(
      '[name=pickup_address_address_line_1]'
    ).value = option.pickup_address.address_line_1;
    document.querySelector(
      '[name=pickup_address_address_line_2]'
    ).value = option.pickup_address.address_line_2;
    document.querySelector(
      '[name=pickup_address_address_line_3]'
    ).value = option.pickup_address.address_line_3;
    document.querySelector(
      '[name=pickup_address_town_city]'
    ).value = option.pickup_address.town_city;
    document.querySelector(
      '[name=pickup_address_county_area]'
    ).value = option.pickup_address.county_area;
    document.querySelector(
      '[name=pickup_address_country]'
    ).value = option.pickup_address.country;

    document.querySelector(
      '[name=pickup_address_contact_name]'
    ).value = option.pickup_address.contact_name;
    document.querySelector(
      '[name=pickup_address_contact_telephone_number]'
    ).value = option.pickup_address.contact_telephone_number;
    document.querySelector(
      '[name=pickup_address_opening_times]'
    ).value = option.pickup_address.opening_times;
    document.querySelector(
      '[name=pickup_address_compound_opening_times]'
    ).value = option.pickup_address.compound_opening_times;

    document.querySelector(
      '[name=dropoff_address_postcode]'
    ).value = option.dropoff_address.postcode;
    document.querySelector(
      '[name=dropoff_address_house_number_or_name]'
    ).value = option.dropoff_address.house_number_or_name;
    document.querySelector(
      '[name=dropoff_address_address_line_1]'
    ).value = option.dropoff_address.address_line_1;
    document.querySelector(
      '[name=dropoff_address_address_line_2]'
    ).value = option.dropoff_address.address_line_2;
    document.querySelector(
      '[name=dropoff_address_address_line_3]'
    ).value = option.dropoff_address.address_line_3;
    document.querySelector(
      '[name=dropoff_address_town_city]'
    ).value = option.dropoff_address.town_city;
    document.querySelector(
      '[name=dropoff_address_county_area]'
    ).value = option.dropoff_address.county_area;
    document.querySelector(
      '[name=dropoff_address_country]'
    ).value = option.dropoff_address.country;

    document.querySelector(
      '[name=dropoff_address_contact_name]'
    ).value = option.dropoff_address.contact_name;
    document.querySelector(
      '[name=dropoff_address_contact_telephone_number]'
    ).value = option.dropoff_address.contact_telephone_number;
    document.querySelector(
      '[name=dropoff_address_opening_times]'
    ).value = option.dropoff_address.opening_times;
    document.querySelector(
      '[name=dropoff_address_compound_opening_times]'
    ).value = option.dropoff_address.compound_opening_times;
    // document.querySelector(
    //   '[name=pickup_preposition]'
    // ).value = option.pickup_preposition;
    // document.querySelector(
    //   '[name=pickup_day]'
    // ).value = option.pickup_day;
    // document.querySelector(
    //   '[name=pickup_month]'
    // ).value = option.pickup_month;
    // document.querySelector(
    //   '[name=pickup_year]'
    // ).value = option.pickup_year;
    // document.querySelector(
    //   '[name=pickup_time]'
    // ).value = option.pickup_time;
    // document.querySelector(
    //   '[name=dropoff_preposition]'
    // ).value = option.dropoff_preposition;
    // document.querySelector(
    //   '[name=dropoff_day]'
    // ).value = option.dropoff_day;
    // document.querySelector(
    //   '[name=dropoff_month]'
    // ).value = option.dropoff_month;
    // document.querySelector(
    //   '[name=dropoff_year]'
    // ).value = option.dropoff_year;
    // document.querySelector(
    //   '[name=dropoff_time]'
    // ).value = option.dropoff_time;
    // document.querySelector(
    //   '[name=vehicle_make]'
    // ).value = option.vehicle.make;
    // document.querySelector(
    //   '[name=vehicle_vin_number]'
    // ).value = option.vehicle.vin_number;
    // document.querySelector(
    //   '[name=vehicle_sliding_door]'
    // ).value = option.vehicle.sliding_door;
    // document.querySelector(
    //   '[name=special_instructions]'
    // ).value = option.special_instructions;
    document.querySelector(
      '[name=notes]'
    ).value = option.notes;
    document.querySelector(
      '[name=invoice_notes]'
    ).value = option.invoice_notes;
    if (option.fleet_paperwork_required) {
      document.querySelector(
        '#yes-fleet-paperwork').
        classList.add('active');
      // document.querySelector(
      //   '#yes-fleet-paperwork input'
      // ).checked = 'checked';
      // document.querySelector(
      // '#yes-fleet-paperwork input'
      // ).classList.add('active');
    }
    else {
      // document.querySelector(
      //   '#no-fleet-paperwork'
      // ).classList.remove('active');
      // document.querySelector(
      //   '#no-fleet-paperwork input'
      // ).checked = 'checked';
      // document.querySelector(
      //   '#yes-fleet-paperwork input'
      // ).classList.remove('active');
    }

    if (option.jet_wash_required) {
      document.querySelector(
        '#yes-jet-wash'
      ).classList.add('active');
      document.querySelector(
        '#yes-jet-wash input'
      ).checked = 'checked';
    }
    else {
      // document.querySelector(
      //   '#no-jet-wash'
      // ).classList.remove('active');
      // document.querySelector(
      //   '#no-jet-wash input'
      // ).checked = 'checked';
    }

    if (option.fuel_included_in_job_price) {
      document.querySelector(
        '#yes-driver-fuel-expense-included-in-job-price'
      ).classList.add('active');
      document.querySelector(
        '#yes-driver-fuel-expense-included-in-job-price input'
      ).checked = 'checked';
    }
    else {
      // document.querySelector(
      //   '#no-driver-fuel-expense-included-in-job-price'
      // ).classList.remove('active');
      // document.querySelector(
      //   '#no-driver-fuel-expense-included-in-job-price input'
      // ).checked = 'checked';
    }
    if (option.type_of_movement) {
      document.querySelector(
        '#used-type-of-movement'
      ).classList.add('active');
      document.querySelector(
        '#used-type-of-movement input'
      ).checked = 'checked';
    }
    else {
      // document.querySelector(
      //   '#new-type-of-movement'
      // ).classList.remove('active');
      // document.querySelector(
      //   '#new-type-of-movement input'
      // ).checked = 'checked';
    }
    this.setJobOptions(option);
  }

  isValidDateFormat(dateString) {
    const regex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
    return _.isString(dateString) && regex.test(dateString);
  }

  onAddNewJobCreate(e) {
    e.preventDefault();
    $('#infomodallabel').html('Processing...');
    let errorMsg = "";
    if(!this.state.unit_term){
      errorMsg += "Please select Unit Term<br>";
    }
    this.state.units.map((unit,index)=>{
        unit.date_of_event = (unit.date_of_event != null) ? moment(unit.date_of_event).format('YYYY-MM-DD HH:mm:ss'):null;
        unit.pickup_date = (unit.pickup_date) ? moment(unit.pickup_date).format('YYYY-MM-DD HH:mm:ss'):null;
        unit.dropoff_date = (unit.dropoff_date) ? moment(unit.dropoff_date).format('YYYY-MM-DD HH:mm:ss') : null;
        unit.required_date = (unit.required_date) ? moment(unit.required_date).format('YYYY-MM-DD HH:mm:ss') : null;
        unit.collection_date = (unit.collection_date) ? moment(unit.collection_date).format('YYYY-MM-DD HH:mm:ss') : null;
        unit.is_same_day_pickup_and_dropoff = (unit.is_same_day_pickup_and_dropoff) ? 1 : 0;
        unit.is_weekend_dropoff_pickup = (unit.is_weekend_dropoff_pickup) ? 1 : 0;
        unit.can_we_dropoff_in_week_before = (unit.can_we_dropoff_in_week_before) ? 1 : 0;
        unit.is_ongoing = (unit.is_ongoing) ? 1 :0;
    });
    $('#infomodal .modal-body').html('Adding new job to system...');
    $('#infomodal').modal();
    let newJobData = {
      api_token: window.api_token,
      customer_id: this.state.selectedCustomerId,
      customer_order_number: document.querySelector('[name=customer_order_number]').value,
      customer_job_number: document.querySelector('[name=customer_job_number]').value,
      job_admin_fee_in_pence: this.state.job_admin_fee_in_pence,
      driver_id:this.state.driver_id,
      disable_job_splitting:this.state.isDisabledJobSplitting,
      pickup_address: {
        postcode: document.querySelector('[name=pickup_address_postcode]').value,
        house_number_or_name: document.querySelector('[name=pickup_address_house_number_or_name]').value,
        address_line_1: document.querySelector('[name=pickup_address_address_line_1]').value,
        address_line_2: document.querySelector('[name=pickup_address_address_line_2]').value,
        address_line_3: document.querySelector('[name=pickup_address_address_line_3]').value,
        town_city: document.querySelector('[name=pickup_address_town_city]').value,
        county_area: document.querySelector('[name=pickup_address_county_area]').value,
        country: document.querySelector('[name=pickup_address_country]').value,
        opening_times: document.querySelector('[name=pickup_address_opening_times]').value,
        compound_opening_times: document.querySelector('[name=pickup_address_compound_opening_times]').value,
        contact_name: document.querySelector('[name=pickup_address_contact_name]').value,
        contact_telephone_number: document.querySelector('[name=pickup_address_contact_telephone_number]').value,
      },
      dropoff_address: {
        postcode: document.querySelector('[name=dropoff_address_postcode]').value,
        house_number_or_name: document.querySelector('[name=dropoff_address_house_number_or_name]').value,
        address_line_1: document.querySelector('[name=dropoff_address_address_line_1]').value,
        address_line_2: document.querySelector('[name=dropoff_address_address_line_2]').value,
        address_line_3: document.querySelector('[name=dropoff_address_address_line_3]').value,
        town_city: document.querySelector('[name=dropoff_address_town_city]').value,
        county_area: document.querySelector('[name=dropoff_address_county_area]').value,
        country: document.querySelector('[name=dropoff_address_country]').value,
        opening_times: document.querySelector('[name=dropoff_address_opening_times]').value,
        compound_opening_times: document.querySelector('[name=dropoff_address_compound_opening_times]').value,
        contact_name: document.querySelector('[name=dropoff_address_contact_name]').value,
        contact_telephone_number: document.querySelector('[name=dropoff_address_contact_telephone_number]').value,
      },
      unit_term:this.state.unit_term,  
      job_type : this.state.jobTypeOption,
      units:this.state.units,
      // special_instructions: document.querySelector(
      //   '[name=special_instructions]').value,
      notes: document.querySelector(
        '[name=notes]').value,
      invoice_notes: document.querySelector(
        '[name=invoice_notes]').value,  
      selected_company:$('#navbarCurrentUserDropdown #data-compnay-id').attr('data-compnay-id')
    };
   
    $.ajax({
      type: "POST",
      url: '/api/v1/portal/jobs/add-new-job',
      data: newJobData,
      dataType: "text/json",
      complete: function(response) {
        let infoModal = $('#infomodal');
        if (response.status === 200) {
          $('#infomodallabel').html('New job added successfully');
          $('#infomodal .modal-body').html(
            $.parseHTML(
              response.responseText.replace(/\"/g,
              ""))
          );
          infoModal.modal();
          infoModal.on('hidden.bs.modal', function() {
            $('form input').val('').removeClass('active');
            $('form select').val('');
            $('form textarea').val('');
            $('form label').removeClass('active');
          });
        }
        else {
          $('#infomodallabel').html('Error adding new job');
          $('#infomodal .modal-body').html(
            $.parseHTML(
              response.responseText.replace(/\"/g,
              ""))
          );
          infoModal.modal();
        }
      }
    });
  }

  handleDropoffDateCalendarChange(date) {
    document.querySelector(
      'select[name=dropoff_day]'
    ).value = ("0" + (date.getDate())).slice(-2);
    document.querySelector(
      'select[name=dropoff_month]'
    ).value = ("0" + (date.getMonth()+1)).slice(-2);
    document.querySelector(
      'select[name=dropoff_year]'
    ).value = date.getFullYear();
    this.setState({
      dropoff_date: date
    });
  }
  handlePickupDateCalendarChange(date) {
    document.querySelector(
      'select[name=pickup_day]'
    ).value = ("0" + (date.getDate())).slice(-2);
    document.querySelector(
      'select[name=pickup_month]'
    ).value = ("0" + (date.getMonth() + 1)).slice(-2);
    document.querySelector(
      'select[name=pickup_year]'
    ).value = date.getFullYear();
    this.setState({pickup_date: date});
  }

  handleAutofillButtonClick(e) {
    e.preventDefault();
    this.setState({
      showAutofill: !this.state.showAutofill
    });
  }
  handleUnitHiredForChange(e){
    this.setState({unit_term:e.target.value});
    if(e.target.value == 'long'){
      $('.unit-type-of-service-container').removeClass('toggle-hide');
    }else{
      $('.unit-type-of-service-container').addClass('toggle-hide');
    }
  }
  handleAddMoreBtnClick(e){
    this.setState({units:[...this.state.units,{
          unit_type:"",
          unit_number:"",
          unit_qty:"",
          date_of_event:null,
          pickup_date:null,
          dropoff_date:null,
          is_same_day_pickup_and_dropoff:false,
          is_weekend_dropoff_pickup:false,
          type_of_unit_service:"",
          number_of_weeks_required:"",
          can_we_dropoff_in_week_before:false,
          is_ongoing:false,
          required_date:null,
          collection_date:null,
          required_date:null
    }] });
  }
  handleUnitNumberChange(e,index){
    this.state.units[index].unit_number = e.target.value;
    this.setState({units:this.state.units});
  }
  handleUnitTypeChange(e,index){
    this.state.units[index].unit_type = e.target.value;
    this.setState({units:this.state.units});
  }
  handleUnitQtyChange(e,index){
    this.state.units[index].unit_qty = e.target.value;
    this.setState({units:this.state.units});
  }
  handleUnitDateOfEventChange(date,index){
    
    this.state.units[index].date_of_event = date;
    this.setState({units:this.state.units});
  }
  handleUnitPickupDateChange(date,index){
    this.state.units[index].pickup_date = date;
    this.setState({units:this.state.units});
  }
  handleUnitDropoffDateChange(date,index){
    this.state.units[index].dropoff_date = date;
    this.setState({units:this.state.units});
  }
  handleIsSamedayPickupAndDRopoffChange(e,index){
    this.state.units[index].is_same_day_pickup_and_dropoff = e.target.checked;
    this.setState({units:this.state.units});
  }
  handleIsWeekendDropoffPickupChange(e,index){
    this.state.units[index].is_weekend_dropoff_pickup = e.target.checked;
    this.setState({units:this.state.units});
  }
  handleRemoveSelectedUnitContainer(e,index){
    this.state.units.splice(index,1);
    this.setState({units:this.state.units});
  }
  handleTypeofUnitService(e,index){
    this.state.units[index].type_of_unit_service = e.target.value;
    this.setState({units:this.state.units});
  }
  handleNumberOfWeeksRequiredChange(e,index){
    this.state.units[index].number_of_weeks_required = e.target.value;
    this.setState({units:this.state.units});
  }
  handleUnitRequiredDateChange(date,index){
    this.state.units[index].required_date = date;
    this.setState({units:this.state.units});
  }
  handleUnitCollectionDateChange(date,index){
    this.state.units[index].collection_date = date;
    this.setState({units:this.state.units});
  }
  handleCanweDropoffInWeekBeforeChange(e,index){
    this.state.units[index].can_we_dropoff_in_week_before = e.target.checked;
    this.setState({units:this.state.units});
  }
  handleIsOngoingOptionChange(e,index){
    this.state.units[index].is_ongoing = e.target.checked;
    this.setState({units:this.state.units});
  }
  handleDisableJobSplitting(e){
    this.setState({isDisabledJobSplitting:e.target.checked});
  }
  handleJobTypeOption(e){
    this.setState({jobTypeOption:e.currentTarget.value});
  }
  setJobOptions(option) {
      const { units } = this.state;
      const { unit } = option;

      if (unit !== null && unit !== undefined) {
          const { unit_type, unit_number, unit_qty, date_of_event, dropoff_date, pickup_date, 
                  is_same_day_pickup_and_dropoff, is_weekend_dropoff_pickup, type_of_unit_service, 
                  number_of_weeks_required, required_date, collection_date, 
                  can_we_dropoff_in_week_before, is_ongoing } = unit;

          const isChecked = (value) => value === 1;

          if (option.unit_hired_term === 'short') {
              this.setState({ unit_term: 'short' }, () => {
                  document.getElementById('short').checked = true;
                  $('.unit-type-of-service-container').addClass('toggle-hide');

                  units[0].unit_type = unit_type !== undefined ? unit_type : units[0].unit_type;
                  units[0].unit_number = unit_number !== undefined ? unit_number : units[0].unit_number;
                  units[0].unit_qty = unit_qty !== undefined ? unit_qty : units[0].unit_qty;

                  if (this.isValidDateFormat(date_of_event))
                      units[0].date_of_event = new Date(date_of_event);
                  if (this.isValidDateFormat(dropoff_date))
                      units[0].dropoff_date = new Date(dropoff_date);
                  if (this.isValidDateFormat(pickup_date))
                      units[0].pickup_date = new Date(pickup_date);

                  units[0].is_same_day_pickup_and_dropoff = is_same_day_pickup_and_dropoff !== undefined ? isChecked(is_same_day_pickup_and_dropoff) : units[0].is_same_day_pickup_and_dropoff;
                  $('[name="is_same_day_pickup_and_dropoff"]').prop('checked', units[0].is_same_day_pickup_and_dropoff);

                  units[0].is_weekend_dropoff_pickup = is_weekend_dropoff_pickup !== undefined ? isChecked(is_weekend_dropoff_pickup) : units[0].is_weekend_dropoff_pickup;
                  $('[name="is_weekend_dropoff_pickup"]').prop('checked', units[0].is_weekend_dropoff_pickup);

                  if(option.job_type && option.job_type === 'delivery') {
                      this.setState({jobTypeOption : option.job_type});
                      document.getElementById('delivery').checked = true;
                  }
                  if(option.job_type && option.job_type === 'service') {
                      this.setState({jobTypeOption : option.job_type});
                      document.getElementById('service').checked = true;
                  }
                  this.setState({ units });
              });
          } else if (option.unit_hired_term === 'long') {
              this.setState({ unit_term: 'long' }, () => {
                  document.getElementById('long').checked = true;
                  $('.unit-type-of-service-container').removeClass('toggle-hide');

                  units[0].unit_type = unit_type !== undefined ? unit_type : units[0].unit_type;
                  units[0].unit_number = unit_number !== undefined ? unit_number : units[0].unit_number;
                  units[0].unit_qty = unit_qty !== undefined ? unit_qty : units[0].unit_qty;
                  units[0].type_of_unit_service = type_of_unit_service !== undefined ? type_of_unit_service : units[0].type_of_unit_service;
                  units[0].number_of_weeks_required = number_of_weeks_required !== undefined ? number_of_weeks_required : units[0].number_of_weeks_required;

                  if (this.isValidDateFormat(required_date))
                      units[0].required_date = new Date(required_date);
                  if (this.isValidDateFormat(collection_date))
                      units[0].collection_date = new Date(collection_date);

                  units[0].can_we_dropoff_in_week_before = can_we_dropoff_in_week_before !== undefined ? isChecked(can_we_dropoff_in_week_before) : units[0].can_we_dropoff_in_week_before;
                  $('[name="can_we_dropoff_in_week_before"]').prop('checked', units[0].can_we_dropoff_in_week_before);

                  units[0].is_ongoing = is_ongoing !== undefined ? isChecked(is_ongoing) : units[0].is_ongoing;
                  $('[name="is_ongoing"]').prop('checked', units[0].is_ongoing);

                  if(option.job_type && option.job_type === 'delivery') {
                      this.setState({jobTypeOption : option.job_type});
                      document.getElementById('delivery').checked = true;
                  }
                  if(option.job_type && option.job_type === 'service') {
                      this.setState({jobTypeOption : option.job_type});
                      document.getElementById('service').checked = true;
                  }

                  this.setState({ units });
              });
          }
      }
  }

  render() {
    let customerId = this.state.selectedCustomerId;
    let driver_id = this.state.driver_id;
    return (
      <Animate
        play={this.state.play}
        start={{opacity: 0}}
        end={{opacity: 1}}
      >
      <form id="add_new_job_form" ref="addNewJobForm">
        <fieldset>
          <div className="row">
          { !this.state.isCustomerLogin ? 
            <div className="col-md-12">
              <button
                onClick={(e) => {this.handleAutofillButtonClick(e)}}
                className="btn btn-lg btn-primary">
                <i className="fa fa-clone">
                </i>&nbsp;
                Autofill from existing job
              </button>
              {(this.state.showAutofill) ?
                <RecentJobsPowerSelect
                handleJobSelection={this.handleJobSelection} />
                : null
              }
            </div>
          :''}
          </div><br /><br />
          
          <div id="place-service-helper-div"></div>
          <div className="row">
            <div className="col-md-4 col-sm-12">
              <h3>Customer</h3>
              <CustomersPowerSelect
                handleCustomerSelection={this.handleCustomerSelection} 
                jobId={this.state.selectedJobId}
                selected={this.state.selectedOption}
                selectedOption={this.state.selectedOption}
                selectedCustomer={this.state.selectedCustomer}
                selectedCustomerId={customerId}
              />
            </div>

            <div className="col-md-2 col-sm-12">
              <label>
                Customer Order Number
              </label>
              <input type="text"
                     name="customer_order_number"
                     className="form-control form-control-lg"
                     placeholder=""/>
            </div>

              <div className="col-md-2 col-sm-12">
                <label>
                  Customer Job Number
                </label>
                <input type="text"
                       name="customer_job_number"
                       className="form-control form-control-lg"
                       placeholder=""/>
              </div>

              <div className="col-md-3 col-sm-12">
                <h3>Driver</h3>
                <DriversPowerSelect 
                handleDriverSelection={this.handleDriverSelection}
                selectedOption={driver_id}
                job={this.state.selectedJob}
                />
              </div>
          </div>

          <div className="row row-spacer-1">
            <div className="col-md-12">
              <h3>Unit Details</h3>
            </div>
          </div>
          
          <div className="row">
                <div className="col-md-2">
                  <div className="form-group unit-term-group">
                    <label>Unit Hired for ?</label>
                    <br></br>
                    <input id="short" className="term-radio-group" type="radio" value="short" name="unit_term" onClick={this.handleUnitHiredForChange}/>
                      <label htmlFor="short" className="radio">
                        &nbsp;Short Term
                      </label>
                    <input id="long" className="term-radio-group" type="radio" value="long" name="unit_term" onClick={this.handleUnitHiredForChange}/>
                        <label htmlFor="long" className="radio">
                          &nbsp;Long Term
                        </label>

                  </div>          
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <label>&nbsp;</label><br></br>
                  <button type="button" disabled={(this.state.unit_term == null || this.state.isDisabledJobSplitting == true) ? true : false} className="btn btn-primary" onClick={(e)=>this.handleAddMoreBtnClick(e)}> + Add more Units ({this.state.units.length})</button>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <label>&nbsp;</label>
                    <div>
                      <label>
                        <input type="checkbox" className="checkbox-custom" name="disable_job_splitting" onChange={(e)=>this.handleDisableJobSplitting(e)}/>
                            &nbsp;&nbsp;Disable Job Splitting ?
                        </label>
                    </div>
                  </div>
                </div>
          </div>

          <div className="row">
            <div className="col-md-2">
              <div className="form-group unit-term-group">
                  <label>Set Job Option</label>
                  <br></br>
                  <input id="delivery" type="radio" value="delivery" name="job_type" 
                  onChange={(e)=>this.handleJobTypeOption(e)} 
                  // checked={(this.state.unit_term == 'short') ? true : false} 
                  />
                    <label htmlFor="delivery" className="radio">
                      &nbsp;Delivery &nbsp;
                    </label>
                  <input id="service" type="radio" value="service" name="job_type" 
                  onChange={(e)=>this.handleJobTypeOption(e)}/>
                    <label htmlFor="service" className="radio">
                      &nbsp;Service
                    </label>
              </div>
            </div>
          </div>
          
            <div className="row">
                    {
                      this.state.units.map((unit,index)=>{
                        return(
                        <div className="row unit-container" key={index}>
                            <div className="col-md-1 col-sm-12">
                              <label>Type of Unit</label>
                              <select name="unit_type" required="required" className="form-control unit-services-dropdown" value={unit.unit_type} onChange={(e)=>this.handleUnitTypeChange(e,index)}>
                                  <option value="">Select Type</option>
                                  <option value="ace">Ace</option>
                                  <option value="basic">Basic</option>
                                  <option value="KS_basic">KS Basic</option>
                                  <option value="KS_HW">KS HW</option>
                                  <option value="hand_wash">Hand wash</option>
                                  <option value="disabled">Disabled</option>
                                  <option value="urinal">Urinal</option>
                                  <option value="eagle_plant_own_service">Eagle plant own service</option>
                                  <option value="a1_own_service">A1 own service</option>
                                  <option value="shower">Shower</option>
                                  <option value="delivery_charge">Delivery Charge</option>
                                  <option value="waste_hire">Waste Hire</option>
                                  <option value="KS_Event" disabled={(this.state.unit_term == 'long') ? false:true}>KS Event</option>
                                  <option value="tressick_toilet" disabled={(this.state.unit_term == 'long') ? false:true}>Tressick Toilet</option>
                                  <option value="tressick_toilet_extra_service" disabled={(this.state.unit_term == 'long') ? false:true}>Tressick Toilet Extra Service</option>
                                  <option value="one_off_service" disabled={(this.state.unit_term == 'long') ? true:false}>One Off Service</option>
                                  <option value="hire_only" disabled={(this.state.unit_term == 'short') ? true:false}>Hire Only</option>
                                  <option value="welfare" disabled={(this.state.unit_term == 'short') ? true:false}>Welfare</option>
                                  <option value="own_unit_service" disabled={(this.state.unit_term == 'short') ? true:false}>Own Unit Service</option>
                                  <option value="service" disabled={(this.state.unit_term == 'short') ? true:false}>Service</option>
                                  <option value="hire_and_service" disabled={(this.state.unit_term == 'short') ? true:false}>Hire and Service</option>
                                </select>
                            </div>

                            <div className="col-md-2">
                              <label>Unit number</label>
                              <input type="text" className="form-control form-control-lg"
                                placeholder="Unit Number"
                                name="unit_number"
                                value={unit.unit_number}
                                id="unit_number" onChange={(e)=>this.handleUnitNumberChange(e,index)} />
                            </div>

                            <div className="col-md-1">
                              <label>Unit Qty</label>
                              <input type="number" className="form-control form-control-lg"
                                placeholder="Unit Qty"
                                min="1"
                                value={unit.unit_qty}
                                name="unit_qty"
                                id="unit_qty" onChange={(e)=>this.handleUnitQtyChange(e,index)} />
                            </div>

                            <div className={(this.state.unit_term == 'long') ? "col-md-2 col-sm-12 unit-type-of-service-container" : "col-md-2 col-sm-12 unit-type-of-service-container toggle-hide"}>
                              <label>Type of Service</label>
                              <select name="type_of_unit_service" value={unit.type_of_unit_service} className="form-control  unit-services-dropdown" onChange={(e)=>this.handleTypeofUnitService(e,index)}>
                                  <option value="">Select Service</option>
                                  <option value="daily">Daily</option>
                                  <option value="weekly">Weekly</option>
                                  <option value="fortnightly" disabled={(unit.unit_type == "welfare") ? true :false}>Fortnightly </option>
                                  <option value="monthly" disabled={(unit.unit_type == "welfare") ? true :false}>Monthly </option>
                                </select>
                            </div>
                            <div className={(this.state.unit_term == 'long') ? "col-md-2" : "col-md-2 toggle-hide"}>
                              <label>Number of weeks required</label>
                              <input type="number" className="form-control form-control-lg"
                                placeholder="Number of weeks"
                                min="1"
                                value={unit.number_of_weeks_required}
                                name="number_of_weeks_required"
                                id="number_of_weeks_required" onChange={(e)=>this.handleNumberOfWeeksRequiredChange(e,index)} />
                            </div>
                            <div className={(this.state.unit_term == 'long') ?"col-md-1 col-sm-12" : "col-md-1 col-sm-12 toggle-hide"}>
                              <label>Required Date</label><br></br>
                              <DatePicker timeInputLabel="Time:" dateFormat="dd/MM/yyyy h:mm aa" showTimeInput placeholderText="Required Date" selected={unit.required_date} onChange={date=>this.handleUnitRequiredDateChange(date,index)} />
                            </div>
                            <div className={(this.state.unit_term == 'long') ? "col-md-1 col-sm-12" : "col-md-1 col-sm-12 toggle-hide"}>
                              <label>Collection Date</label><br></br>
                              <DatePicker timeInputLabel="Time:" dateFormat="dd/MM/yyyy h:mm aa" showTimeInput placeholderText="Collection Date" selected={unit.collection_date} onChange={date=>this.handleUnitCollectionDateChange(date,index)} />
                            </div>
                            <div className={(this.state.unit_term == 'long') ? "col-md-2 col-sm-12 checkbox-custom-group":"col-md-2 col-sm-12 checkbox-custom-group toggle-hide"}>
                              <label>&nbsp;</label>
                              <div>
                                <label>
                                  <input type="checkbox" className="checkbox-custom" name="can_we_dropoff_in_week_before" value={unit.can_we_dropoff_in_week_before} onChange={(e)=>this.handleCanweDropoffInWeekBeforeChange(e,index)}/>
                                      &nbsp;&nbsp;Can we drop off in the week before ?
                                  </label>
                              </div>
                            </div>
                            <div className={(this.state.unit_term == 'long') ? "col-md-2 col-sm-12 checkbox-custom-group":"col-md-2 col-sm-12 checkbox-custom-group toggle-hide"}>
                              <label>&nbsp;</label>
                              <div>
                                <label>
                                  <input type="checkbox" className="checkbox-custom" name="is_ongoing" value={unit.is_ongoing} onChange={(e)=>this.handleIsOngoingOptionChange(e,index)}/>
                                      &nbsp;&nbsp;Ongoing ?
                                  </label>
                              </div>
                            </div>

                            <div className={(this.state.unit_term == 'short') ? "col-md-1 col-sm-12 custom-date-format":"col-md-1 col-sm-12 custom-date-format toggle-hide"}>
                              <label>Date of Event</label><br></br>
                              <DatePicker timeInputLabel="Time:" dateFormat="dd/MM/yyyy h:mm aa" showTimeInput placeholderText="Date of Event" selected={unit.date_of_event} onChange={date=>this.handleUnitDateOfEventChange(date,index)} />
                            </div>
                            <div className={(this.state.unit_term == 'short') ? "col-md-1 col-sm-12 custom-date-format":"col-md-1 col-sm-12 custom-date-format toggle-hide"}>
                              <label>Dropoff Date</label><br></br>
                              <DatePicker timeInputLabel="Time:" dateFormat="dd/MM/yyyy h:mm aa" showTimeInput placeholderText="Dropoff Date" selected={unit.dropoff_date} onChange={date=>this.handleUnitDropoffDateChange(date,index)} />
                            </div>
                            <div className={(this.state.unit_term == 'short') ? "col-md-1 col-sm-12 custom-date-format" : "col-md-1 col-sm-12 custom-date-format toggle-hide"}>
                              <label>Pickup Date</label><br></br>
                              <DatePicker timeInputLabel="Time:" dateFormat="dd/MM/yyyy h:mm aa" showTimeInput placeholderText="Pickup Date" selected={unit.pickup_date} onChange={date=>this.handleUnitPickupDateChange(date,index)} />
                            </div>
                            <div className={(this.state.unit_term == 'short') ? "col-md-2 col-sm-12 checkbox-custom-group" : "col-md-2 col-sm-12 checkbox-custom-group toggle-hide"}>
                              <label>&nbsp;</label>
                              <div>
                                <label><input type="checkbox" className="checkbox-custom" name="is_same_day_pickup_and_dropoff" value={unit.is_same_day_pickup_and_dropoff} onChange={(e)=>this.handleIsSamedayPickupAndDRopoffChange(e,index)} />&nbsp;&nbsp;Same day pick up and drop off ?</label>
                              </div>
                            </div>
                            <div className={(this.state.unit_term == 'short') ? "col-md-2 col-sm-12 checkbox-custom-group" : "col-md-2 col-sm-12 checkbox-custom-group toggle-hide"}>
                              <label>&nbsp;</label>
                              <div>
                                <label><input type="checkbox" className="checkbox-custom" name="is_weekend_dropoff_pickup" value={unit.is_weekend_dropoff_pickup} onChange={(e)=>this.handleIsWeekendDropoffPickupChange(e,index)}/>&nbsp;&nbsp;Weekend drop off/ pick up ?</label>
                              </div>
                            </div>
                            {(index != 0) ?
                              <div className="remove-current-unit" title="Remove Unit"><a className="alert alert-danger" onClick={(e)=>this.handleRemoveSelectedUnitContainer(e,index)}><i className="fa">&#xf00d;</i></a></div>
                            : ''}
                        </div>
                        )
                      })
                    }
            </div>

            <div className="row row-spacer-1">
              <div className="col-md-6 d-none">
                <h3>Yard Address</h3>
              <div className="form-group address-finder">
                <div id="pickup_address_postcode_lookup">
                </div>
              </div>
              <div className="form-group row">
                <div className="col-md-4">
                  <label htmlFor="pickup_address_house_number_or_name">
                    House Number or Name:
                  </label>
                </div>
                <div className="col-md-8">
                  <input type="text" name="pickup_address_house_number_or_name"
                         id="pickup_address_house_number_or_name"
                         className="form-control form-control-lg"  />
                </div>
              </div>

              <div className="form-group row">
                <div className="col-md-4">
                  <label htmlFor="pickup_address_address_line_1">
                    Address Line 1:
                  </label>
                </div>
                <div className="col-md-8">
                  <input type="text" name="pickup_address_address_line_1"
                    id="pickup_address_address_line_1"
                    className="form-control form-control-lg" value="Unit 57" />
                </div>
              </div>

              <div className="form-group row">
                <div className="col-md-4">
                  <label htmlFor="pickup_address_address_line_2">
                    Address Line 2:
                  </label>
                </div>
                <div className="col-md-8">
                  <input type="text" name="pickup_address_address_line_2"
                    id="pickup_address_address_line_2"
                    className="form-control form-control-lg" value="Ditton Priors Trading Estate" />
                </div>
              </div>

              <div className="form-group row">
                <div className="col-md-4">
                  <label htmlFor="pickup_address_address_line_3">
                    Address Line 3:
                  </label>
                </div>
                <div className="col-md-8">
                  <input type="text" name="pickup_address_address_line_3"
                    id="pickup_address_address_line_3"
                    className="form-control form-control-lg" value="Station Road"/>
                </div>
              </div>

              <div className="form-group row">
                <div className="col-md-4">
                <label htmlFor="pickup_address_town_city">
                  Town/City:
                </label>
                </div>
                <div className="col-md-8">
                <input type="text" name="pickup_address_town_city"
                  id="pickup_address_town_city"
                  className="form-control form-control-lg" value="Ditton Priors, Bridgnorth"/>
                </div>
              </div>

              <div className="form-group row">
                <div className="col-md-4">
                <label htmlFor="pickup_address_county_area">
                  County/Area:
                </label>
                </div>
                <div className="col-md-8">
                <input type="text" name="pickup_address_county_area"
                  id="pickup_address_county_area"
                  className="form-control form-control-lg" value="Shropshire"/>
                </div>
              </div>

              <div className="form-group row">
                <div className="col-md-4">
                <label htmlFor="pickup_address_country">
                  Country:
                </label>
                </div>
                <div className="col-md-8">
                <input type="text" name="pickup_address_country"
                  id="pickup_address_country"
                  className="form-control form-control-lg" />
                </div>
              </div>

              <div className="form-group row">
                <div className="col-md-4">
                  <label htmlFor="pickup_address_postcode">
                    Postcode:  
                  </label>
                </div>
                <div className="col-md-8">
                  <input type="text" name="pickup_address_postcode"
                    id="pickup_address_postcode"
                    className="form-control form-control-lg" value="WV16 6SS"/>
                </div>
              </div>


                <hr />

              <div className="form-group row">
                <div className="col-md-4">
                  <label htmlFor="pickup_address_opening_times">
                    Opening/Closing Times:
                  </label>
                </div>
                <div className="col-md-8">
                  <input type="text" name="pickup_address_opening_times"
                         id="pickup_address_opening_times"
                         placeholder="e.g. 9am to 11am, 1pm to 5pm"
                         className="form-control form-control-lg" />
                </div>
              </div>

                <div className="form-group row">
                  <div className="col-md-4">
                    <label htmlFor="pickup_address_compound_opening_times">
                      Compound Opening/Closing Times:
                    </label>
                  </div>
                  <div className="col-md-8">
                    <input type="text" name="pickup_address_compound_opening_times"
                           id="pickup_address_compound_opening_times"
                           placeholder="e.g. 9am to 11am, 1pm to 5pm"
                           className="form-control form-control-lg" />
                  </div>
                </div>

              <div className="form-group row">
                <div className="col-md-4">
                  <label htmlFor="pickup_address_contact_name">
                    Contact Name:
                  </label>
                </div>
                <div className="col-md-8">
                  <input type="text" name="pickup_address_contact_name"
                         id="pickup_address_contact_name"
                         className="form-control form-control-lg" />
                </div>
              </div>

              <div className="form-group row">
                <div className="col-md-4">
                  <label
                    htmlFor="pickup_address_contact_telephone_number">
                    Contact Telephone Number:
                  </label>
                </div>
                <div className="col-md-8">
                  <input
                    type="text"
                    name="pickup_address_contact_telephone_number"
                    id="pickup_address_contact_telephone_number"
                    className="form-control form-control-lg" />
                </div>
              </div>

            </div>

            <div className="col-md-6">
              <h3>Service Address</h3>
              <div className="form-group address-finder">
                  <div id="dropoff_address_postcode_lookup">
                  </div>
              </div>
              <div className="form-group row">
                <div className="col-md-4">
                <label htmlFor="dropoff_address_house_number_or_name">
                  House Number or Name:
                </label>
                </div>
                <div className="col-md-8">
                <input type="text" name="dropoff_address_house_number_or_name"
                  id="dropoff_address_house_number_or_name"
                  className="form-control form-control-lg" />
                </div>
              </div>

              <div className="form-group row">
                <div className="col-md-4">
                <label htmlFor="dropoff_address_address_line_1">
                  Address Line 1:
                </label>
                </div>
                <div className="col-md-8">
                <input type="text" name="dropoff_address_address_line_1"
                  id="dropoff_address_address_line_1"
                  className="form-control form-control-lg" />
                </div>
              </div>

              <div className="form-group row">
                <div className="col-md-4">
                <label htmlFor="dropoff_address_address_line_2">
                  Address Line 2:
                </label>
                </div>
                <div className="col-md-8">
                <input type="text" name="dropoff_address_address_line_2"
                  id="dropoff_address_address_line_2"
                  className="form-control form-control-lg" />
                </div>
              </div>

              <div className="form-group row">
                <div className="col-md-4">
                <label htmlFor="dropoff_address_address_line_3">
                  Address Line 3:
                </label>
                </div>
                <div className="col-md-8">
                <input type="text" name="dropoff_address_address_line_3"
                  id="dropoff_address_address_line_3"
                  className="form-control form-control-lg" />
                </div>
              </div>

              <div className="form-group row">
                <div className="col-md-4">
                  <label htmlFor="dropoff_address_town_city">
                    Town/City:
                  </label>
                </div>
                <div className="col-md-8">
                  <input type="text" name="dropoff_address_town_city"
                    id="dropoff_address_town_city"
                    className="form-control form-control-lg" />
                </div>
              </div>

              <div className="form-group row">
                <div className="col-md-4">
                  <label htmlFor="dropoff_address_county_area">
                    County/Area:
                  </label>
                </div>
                <div className="col-md-8">
                  <input type="text" name="dropoff_address_county_area"
                    id="dropoff_address_county_area"
                    className="form-control form-control-lg" />
                </div>
              </div>

              <div className="form-group row">
                <div className="col-md-4">
                <label htmlFor="dropoff_address_country">
                  Country:
                </label>
                </div>
                <div className="col-md-8">
                <input type="text" name="dropoff_address_country"
                  id="dropoff_address_country"
                  className="form-control form-control-lg" />
                </div>
              </div>

              <div className="form-group row">
                <div className="col-md-4">
                <label htmlFor="dropoff_address_postcode">
                  Postcode:
                </label>
                </div>
                <div className="col-md-8">
                  <input type="text" name="dropoff_address_postcode"
                    id="dropoff_address_postcode"
                    className="form-control form-control-lg" />
                </div>
              </div>

              <hr />

              <div className="form-group row">
                <div className="col-md-4">
                  <label htmlFor="dropoff_address_opening_times">
                    Opening/Closing Times:
                  </label>
                </div>
                <div className="col-md-8">
                  <input type="text" name="dropoff_address_opening_times"
                         id="dropoff_address_opening_times"
                         placeholder="e.g. 9am to 11am, 1pm to 5pm"
                         className="form-control form-control-lg" />
                </div>
              </div>

              <div className="form-group row">
                <div className="col-md-4">
                  <label htmlFor="dropoff_address_compound_opening_times">
                    Compound Opening/Closing Times:
                  </label>
                </div>
                <div className="col-md-8">
                  <input type="text" name="dropoff_address_compound_opening_times"
                         id="dropoff_address_compound_opening_times"
                         placeholder="e.g. 9am to 11am, 1pm to 5pm"
                         className="form-control form-control-lg" />
                </div>
              </div>

              <div className="form-group row">
                <div className="col-md-4">
                  <label htmlFor="dropoff_address_contact_name">
                    Contact Name:
                  </label>
                </div>
                <div className="col-md-8">
                  <input type="text" name="dropoff_address_contact_name"
                         id="dropoff_address_contact_name"
                         className="form-control form-control-lg" />
                </div>
              </div>

              <div className="form-group row">
                <div className="col-md-4">
                  <label
                    htmlFor="dropoff_address_contact_telephone_number">
                    Contact Telephone Number:
                  </label>
                </div>
                <div className="col-md-8">
                  <input
                    type="text"
                    name="dropoff_address_contact_telephone_number"
                    id="dropoff_address_contact_telephone_number"
                    className="form-control form-control-lg" />
                </div>
              </div>
            </div>
          </div>

          <div className="row row-spacer-1">
            {/* <div className="col-md-6">
              <h3>
                <label htmlFor="special_instructions">
                  Special Instructions
                </label>
              </h3>
              <textarea className="form-control form-control-lg text-center"
                        name="special_instructions"
                        id="special_instructions"
                        value={this.state.specialInstructions}
                        onChange={(e) => this.setState({ specialInstructions: e.target.value })}         
               >
              </textarea>
            </div> */}

            <div className="col-md-6">
              <h3>
                <label htmlFor="notes">Notes</label>
              </h3>
              <textarea className="form-control form-control-lg text-center"
                        name="notes" id="notes">
              </textarea>
            </div>
            <div className="col-md-6">
              <h3>
                <label htmlFor="invoice_notes">Invoice Notes</label>
              </h3>
              <textarea className="form-control form-control-lg text-center"
                        name="invoice_notes" id="invoice_notes">
              </textarea>
            </div>
          </div>

          <div className="row text-center row-spacer-1">
            <div className="col-md-12">
              <button className="btn btn-lg btn-primary" onClick={this.onAddNewJobCreate} type="button"> Add New Job </button>
            </div>
          </div>
          <br /><br /><br /><br /><br />
        </fieldset>
      </form>
      </Animate>
    );
  }
}

if (document.getElementById(
  'react-component-g4-logistics-portal-add-new-job')) {
  ReactDOM.render(<AddNewJob />,
    document.getElementById(
      'react-component-g4-logistics-portal-add-new-job')
  );
}
